/* eslint-disable indent */
import React from 'react';
import Modal from 'react-modal';
import Select, { components } from 'react-select';
import moment from 'moment';
import _ from "lodash";
import DatePicker from 'react-datepicker';

import './index.scss';
import closeIcon from '../../../../assets/images/close_icon_dark.svg'
import deleteIcon from '../../../../assets/images/delete-blue.svg'
import utils from '../../../../lib/utils';

const timeSelectDropdown = [
    {label:'Days of Week',value:'WEEKLY'},
    {label:'Specific Date',value:'SPECIFIC_DATE'},
    { label:'Recurring',value:'RECURRENCE'}
];

const daysOfWeek = [
  {label:'Sunday',value:'SUNDAY'},
  {label:'Monday',value:'MONDAY'},
  {label:'Tuesday',value:'TUESDAY'},
  {label:'Wednesday',value:'WEDNESDAY'},
  {label:'Thursday',value:'THURSDAY'},
  {label:'Friday',value:'FRIDAY'},
  {label:'Saturday',value:'SATURDAY'},
];

const frequencyUnitDropdown = [
  {label:'Day',value:'DAILY'},
  {label:'Week',value:'WEEKLY'},
  {label:'Month',value:'MONTHLY'}
];

const prefrenceDropdown = [
  {label:'Every half an hour',value:'HALF_AN_HOUR'},
  {label:'Top of the hour',value:'TOP_OF_HOUR'},
  {label:'Every hour',value:'EVERY_HOUR'},
  {label:'Every fifteen minutes',value:'EVERY_FIFTEEN_MINUTES'},
  {label:'Every twenty minutes',value: 'EVERY_TWENTY_MINUTES'},
  {label:'Every ten minutes',value:'EVERY_TEN_MINUTES'},
  {label:'None',value:'NONE'},
]
const generateTimeRange =(from,to)=>{
    let range = [];
    for(let i=from;i<=to;i++){
        range.push({label:pad(i),value:i})
    }
    return range;
}
const pad =(d)=>{
  return (d < 10) ? '0' + d.toString() : d.toString();
}

const capitalize = s => s && s[0].toUpperCase() + s.slice(1)

const timeOfDay = generateTimeRange(1,12);
const fequencyRange = generateTimeRange(1,31);

const minutes = generateTimeRange(0,59);

const dropdownCustomStyle = {
    control: base => ({
      ...base,
      border: '1px solid #CFD0D1',
      // This line disable the blue border
      padding: '6px 12px',
      boxShadow: 'none',
      outLine:'none',
      '&:hover': {
        border: '1px solid #CFD0D1',
      }
    }),
    option: base => ({
      ...base,
      padding: '8px 15px'
    }),
    valueContainer: base => ({
      ...base,
      padding: '0px'
    }),
    menuList: (provided, state) => ({
      ...provided,
      maxHeight: '250px'
    }),
  };
const timeCustomStyle ={
  control: base => ({
    ...base,
    border: '1px solid #CFD0D1',
    // This line disable the blue border
    padding: '6px 0px 6px 6px',
    boxShadow: 'none',
    outLine:'none',
    marginLeft: '5px',
    '&:hover': {
      border: '1px solid #CFD0D1',
    }
  }),
  valueContainer: base => ({
    ...base,
    padding: '0px',
    width:'29px'
  }),
  indicatorContainer : base => ({
    ...base,
  }),
  menu: (base) => ({
    ...base,
    width: "max-content",
    minWidth: "100%"
}),
};

  const DropdownIndicator = props => {
    return (
      components.DropdownIndicator && (
        <components.DropdownIndicator {...props}>
          <i className="material-icons custom">arrow_drop_down</i>
        </components.DropdownIndicator>
      )
    );
  };

  const CustomOption = ({ innerProps, label, isSelected }) => {
    console.log('isSelected',isSelected);
    return <div {...innerProps} className="custom-input-option">
      <input className="custom-input-select" type="checkbox" checked={isSelected} readOnly />
      <span className="custom-input-option_lable">{label}</span>
    </div>
  };

  const isInArray =(obj, array) =>{
    return array.some(item => item.rule_id === obj.rule_id);
  }

  const mergeArrays = (arr1, arr2) =>{
    // Concatenate the two arrays
    const combinedArray = [...arr1, ...arr2];
    
    // Create a map to ensure uniqueness based on the 'id' property
    const uniqueMap = new Map();
    
    combinedArray.forEach(item => {
        if (uniqueMap.has(item.id)) {
            // Merge objects with the same id
            uniqueMap.set(item.id, { ...uniqueMap.get(item.id), ...item });
        } else {
            // Add new object
            uniqueMap.set(item.id, item);
        }
    });
    
    // Convert map values back to an array
    return Array.from(uniqueMap.values());
}

const filterService = (services) => {
  const filterdService = services? services.filter(service=>service.kind==='SESSION'):[];
  if(filterdService.length>1){
    filterdService.push({name:'All Service',id:'ALL'});
  }
  return filterdService;
}

const filterServiceForAPI = (services) => {
  const filterdService = services? services.filter(service=>service.kind==='SESSION'):[];
  return filterdService;
}

Modal.setAppElement('#root');

class InstallLayover extends React.Component {
  constructor(props) {
    super(props);
    this.startRef = React.createRef();
    this.state = {
      timeType:'WEEKLY',
      selecedDayofWeek:[],
      selectedDate: new Date(),
      frequency:'WEEK',
      frequencyStartHour:9,
      frequencyStartMinute:0,
      frequencyStartDominion:'AM',
      frequencyEndDominion:'PM',
      frequencyEndHour:5,
      frequencyEndMinute:0,
      breakData:[],
      services:[],
      resource:[],
      preference: null,
      staffs:[],
      frequencyunit:'DAY',
      frequencyvalue:1
    };
  }
  componentWillReceiveProps(nextProps) {
    const { editSchedule,  editScheduleData } = nextProps;
    if(editSchedule){
      console.log('editScheduleData',editScheduleData);
    }
  }

  componentDidMount(){
    const { editSchedule,  editScheduleData, duplicateSchedule, business, schedules } = this.props;
    const { services, staffs:business_staff, resources } = business.details;
    const staffs = schedules.staff_list || business_staff;
    console.log('editSchedule',editSchedule);
    if(editSchedule || duplicateSchedule){
      console.log('editScheduleData',editScheduleData);
      const breakTime = editScheduleData?.schedule_breaks?.map(breakrule=>({
        breakStartHour: eval(moment(breakrule.start,'HH:mm:ss').format('h')),
        breakStartMinute: eval(moment(breakrule.start,'HH:mm:ss').format('m')),
        breakStartDominion:moment(breakrule.start,'HH:mm:ss').format('A'),
        breakEndDominion:moment(breakrule.end,'HH:mm:ss').format('A'),
        breakEndHour: eval(moment(breakrule.end,'HH:mm:ss').format('h')),
        breakEndMinute: eval(moment(breakrule.end,'HH:mm:ss').format('m')),
        rule_id: breakrule.rule_id
      }))
      const ifAllService = _.isEqual(_.sortBy(editScheduleData.service_ids), _.sortBy(filterServiceForAPI(services).map(service=>service.id)))
      const selectedService = ifAllService? [{name:'All Service',id:'ALL'}] : services.filter(service=> editScheduleData.service_ids.includes(service.id));
      this.setState({
      timeType: editScheduleData.schedule_type,
      selecedDayofWeek: editScheduleData.days.map(day=>({'label':capitalize(day.toLowerCase()) , 'value':day})),
      selectedDate: editScheduleData.date? new Date(editScheduleData.date) : new Date(),
      frequencyStartHour: eval(moment(editScheduleData.time_slot.start,'HH:mm:ss').format('h')),
      frequencyStartMinute: eval(moment(editScheduleData.time_slot.start,'HH:mm:ss').format('m')),
      frequencyStartDominion: moment(editScheduleData.time_slot.start,'HH:mm:ss').format('A'),
      frequencyEndHour: eval(moment(editScheduleData.time_slot.end,'HH:mm:ss').format('h')),
      frequencyEndMinute: eval(moment(editScheduleData.time_slot.end,'HH:mm:ss').format('m')),
      frequencyEndDominion: moment(editScheduleData.time_slot.end,'HH:mm:ss').format('A'),
      breakData: breakTime,
      services: selectedService,
      resource: resources.filter(resource=> editScheduleData.resource_ids.includes(resource.id)),
      preference:editScheduleData.booking_interval,
      staffs: staffs.filter(staff=>editScheduleData.staff_ids.includes(staff.id)),
      frequencyunit:editScheduleData.recurrence_unit,
      frequencyvalue:editScheduleData.recurrence_count
      })
    }
  }
  
  onChange=(event)=>{
    console.log('EVENT',event);
    const { editSchedule } = this.props;
    let val = event.target.value;
    const listofFields = ['timeType', 'frequencyunit','frequencyvalue','frequencyStartMinute','frequencyStartHour','frequencyEndHour','frequencyEndMinute','preference'];
    const listofArrays = ['services', 'resource', 'staffs'];
    if(editSchedule && listofArrays.includes(event.target.name)){
      val = utils.ensureArray(val)
    }
    if(listofArrays.includes(event.target.name)){
    if(val && val.filter(service=>service.id==='ALL')?.length>0){
      val = val.filter(service=>service.id==='ALL');
    }else{
      val = val?val:[];
    }
   } else if(listofFields.includes(event.target.name)){
      val = val.value;
    }else if(event.target.name === 'selecedDayofWeek' ){
      val = val?val:[];
    }
    this.setState({
      [event.target.name]: val
    })
    console.log('STATE 123',this.state);
  }

  onChangeBreak=(event)=>{
    let breakCopy = _.cloneDeep(this.state.breakData);
    breakCopy[event.target.index][event.target.name] =event.target.value.value
    this.setState({
      breakData: breakCopy
    })
  }
  handleChangeDate = (date, type) => {
    this.setState({
      [type]: date,
    });
  };

  datePickerVisible = (event, ref) => {
    const node = ref.current;
    node.setFocus();
  };
  deleteBreak=(removeIndex)=>{
    let breakCopy = _.cloneDeep(this.state.breakData);
    breakCopy.splice(removeIndex, 1);
    console.log('breakCopy1',breakCopy)
    this.setState({
      breakData: breakCopy
    })
    
  }
  disabledAddButton=()=>{
    const { services, staffs, preference , resource, timeType, selecedDayofWeek} = this.state;
    const { schedules, groupByKey } = this.props;
    const disabled = ((timeType === 'WEEKLY' && selecedDayofWeek.length<1) || (groupByKey === 'staff_ids' && resource.length<1) || services.length<1 || (groupByKey === 'resource_ids' && staffs.length<1) || preference === null || schedules?.addScheduleDefinition)
    console.log('disabled',preference, disabled,(groupByKey === 'staff_ids' && resource.length<1),  services.length<1,(groupByKey === 'resource_ids' && staffs.length<1),  preference === null ,schedules?.addScheduleDefinition )
    return disabled;
  }

  gerBreakComponent=(index, data)=>{
    console.log('BREAK',index,data);
    const {breakStartHour, breakStartMinute , breakEndHour,breakEndMinute, breakStartDominion, breakEndDominion} = data;
                 return <div className="time-of-day">
                        <div className="time-of-day_label">From</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={timeOfDay.filter(c => c.value === breakStartHour)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={timeOfDay}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChangeBreak({target:{name:'breakStartHour',index, value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={minutes.filter(c => c.value === breakStartMinute)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={minutes}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChangeBreak({target:{name:'breakStartMinute',index, value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <div className="time-of-day_dominion" onClick={()=>this.onChangeBreak({target:{name:'breakStartDominion',index, value:{value:breakStartDominion==='AM'?'PM':'AM'}}})}>{breakStartDominion}</div>
                        <div className="time-of-day_divider">-</div>
                        <div className="time-of-day_label">To</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={timeOfDay.filter(c => c.value === breakEndHour)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={timeOfDay}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChangeBreak({target:{name:'breakEndHour',index, value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={minutes.filter(c => c.value === breakEndMinute)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={minutes}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChangeBreak({target:{name:'breakEndMinute', index, value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <div className="time-of-day_dominion" onClick={()=>this.onChangeBreak({target:{name:'breakEndDominion',index, value:{value:breakEndDominion==='PM'?'AM':'PM'}}})}>{breakEndDominion}</div>
                        <div className="time-of-day_deletaction"><img src={deleteIcon} onClick={()=>this.deleteBreak(index)}/></div>
                    </div>
  }
  addBreak=()=>{
    let breakCopy = [...this.state.breakData];
    breakCopy.push({
      breakStartHour:1,
      breakStartMinute:0,
      breakStartDominion:'AM',
      breakEndHour:1,
      breakEndMinute:0,
      breakEndDominion:'PM',
    });
    this.setState({
      breakData: breakCopy
    })
  }

  getServiceIds = (services) => {
    if(services.length === 1 && services[0].id === 'ALL'){
      const { business } = this.props;
      const { services} = business.details;
      const servicesFiltered  = filterServiceForAPI(services);
      return servicesFiltered;
    }
    return services;

  }

  addTime=()=>{
    const { business, groupByKey, selectedData, editSchedule,  editScheduleData } = this.props;
    const { timeType, resource, services, selecedDayofWeek , selectedDate, preference,  
      frequencyStartHour, frequencyStartMinute,frequencyEndHour, frequencyEndMinute,breakData, frequencyvalue, frequencyunit, frequencyStartDominion, frequencyEndDominion, staffs} = this.state;
   const addOrUpdate = editSchedule? "UPDATE":"ADD";
   console.log('selectedData',groupByKey,selectedData , editScheduleData)
    let breakRules = breakData.map((breakTime,index)=>
      ({
            "start": moment(breakTime.breakStartHour+':'+breakTime.breakStartMinute+' '+breakTime.breakStartDominion,'h:m A').format('HH:mm:ss'),
            "end": moment(breakTime.breakEndHour+':'+breakTime.breakEndMinute+' '+breakTime.breakEndDominion,'h:m A').format('HH:mm:ss')
        }
    ));

  
  // Find objects in array1 that are not in array2
  // let difference = editScheduleData?.schedule_breaks?.filter(obj => !isInArray(obj, breakRules))|| [];
  // console.log('difference',difference, breakRules);
  // if(editSchedule){
  // for(let i=0;i<difference.length;i++){
  //   difference[i].rule_status = 'INVALID';
  // }
  // breakRules = breakRules
  // }
    console.log('addData', breakRules); 
    const addData = {
      ...(editSchedule && {"id":editScheduleData.id}),
      "location_id": business?.details?.locations[0]?.id,
      "schedule_type": timeType ,  //WEEKLY, SPECIFIC_DATE, RECURRENCE
      "service_ids": this.getServiceIds(services).map(service=>service.id),
      "staff_ids": groupByKey === 'staff_ids'? [selectedData.id] : staffs.map(staff=>staff.id),
      "resource_ids":  groupByKey === 'resource_ids'? [selectedData.id] : resource.map(res=>res.id),
      "time_slot" : {
          "start": moment(frequencyStartHour+':'+frequencyStartMinute+' '+frequencyStartDominion,'h:m A').format('HH:mm:ss'),
          "end": moment(frequencyEndHour+':'+frequencyEndMinute+' '+frequencyEndDominion,'h:m A').format('HH:mm:ss')
      },
      ...(timeType==='WEEKLY' && {"days": selecedDayofWeek.map(day=>day.value)}),
      ...(timeType!=='WEEKLY' &&{ "date": moment(selectedDate).format('YYYY-MM-DD')}),
      ...(timeType==='RECURRENCE' && {"recurrence_unit": frequencyunit,"recurrence_count": frequencyvalue}), // required for scheduleType = RECURRENCE
      "booking_interval": preference,
      "schedule_breaks": breakRules
  }
  if(editSchedule){
    this.props.editScheduleAPI({data: addData, business_id: this.props.bzid});
  }else{
    this.props.addSchedule({data: addData, business_id: this.props.bzid});
  }
  console.log('addData', addData);
  }

  render() {
    const { modelopen, closeServiceModal, schedules, deleteServiceType, selectedService, business, groupByKey, selectedData, editSchedule,  editScheduleData  } = this.props;
    const{ timeType, selecedDayofWeek , selectedDate, frequencyvalue, frequencyunit , frequencyStartHour, frequencyStartMinute , frequencyEndHour,frequencyEndMinute,
       breakData, preference, resource , service , frequencyStartDominion, frequencyEndDominion} = this.state;
       
    console.log('resources', this.state.resource);
    const { services, resources, staffs:business_staff} = business.details;
    const staffs = schedules.staff_list || business_staff;
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={closeServiceModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="pc-modal-header">
              <div className="title"><div>{editSchedule?'Edit':'Add'} time</div>
                  <div className="title_for">for {selectedData.name}</div>
              </div>
              <button className="modal-close" onClick={closeServiceModal}>
                <img src={closeIcon}></img>
              </button>
              <div className="modal-description">
                    <div className="frequency-time">
                        <div className="label">Time</div>
                        <div className="frequency-time_dropdwns">
                        <div className="frequency-time_dropdwns_select">
                            <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={timeSelectDropdown.filter(c => c.value === timeType)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={timeSelectDropdown}
                            onChange={(event) => {
                              this.onChange({target:{name:'timeType', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                            />
                        </div>
                       {timeType === 'WEEKLY' &&
                       <div className="frequency-time_dropdwns_dateselect">
                            <Select
                            components={{
                              Option: CustomOption, DropdownIndicator, IndicatorSeparator: () => null 
                            }}
                            value={daysOfWeek.filter(item1 =>selecedDayofWeek.some(item2 => item2.value === item1.value))}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={daysOfWeek}
                            isMulti
                            noOptionsMessage={() => null} 
                            closeMenuOnSelect={false}
                            onChange={(event) => {
                              this.onChange({target:{name:'selecedDayofWeek', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                            />
                        </div>}
                         {timeType !== 'WEEKLY' &&<div className="frequency-time_dropdwns_dateselect">
                          <div onClick={(e) =>
                                  this.datePickerVisible(e, this.startRef)
                                }>
                                </div>
                          <DatePicker
                                  ref={this.startRef}
                                  selected={selectedDate}
                                  onChange={(date) =>
                                    this.handleChangeDate(date, 'selectedDate')
                                  }
                                  dateFormat="MMMM d, yyyy"
                                  placeholderText="Select Date"
                                  minDate={new Date()}
                                />
                        </div>
                        }

                        </div>
                    </div>
                    {timeType === 'RECURRENCE' &&
                    <div className="frequency-type">
                        <div className="label">Frequency(Repeat every)</div>
                        <div className="frequency-time_dropdwns">
                        <div className="frequency-time_dropdwns_select">
                            <Select
                                components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                                value={fequencyRange.filter(c => c.value === frequencyvalue)}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                options={fequencyRange}
                                placeholder=''
                                onChange={(event) => {
                                  this.onChange({target:{name:'frequencyvalue', value:event}});
                                  }}
                                styles={timeCustomStyle}
                            />
                        </div>
                        <div className="frequency-time_dropdwns_dateselect">
                            <Select
                                  components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                                  value={frequencyUnitDropdown.filter(c => c.value === frequencyunit)}
                                  getOptionLabel={(option) => option.label}
                                  getOptionValue={(option) => option.value}
                                  options={frequencyUnitDropdown}
                                  onChange={(event) => {
                                    this.onChange({target:{name:'frequencyunit', value:event}});
                                    }}
                                  styles={dropdownCustomStyle}
                              />
                        </div>
                        </div>
                    </div>
                    }
                    <div className="time-of-day">
                        <div className="time-of-day_label">From</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={timeOfDay.filter(c => c.value === frequencyStartHour)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={timeOfDay}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChange({target:{name:'frequencyStartHour', value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={minutes.filter(c => c.value === frequencyStartMinute)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={minutes}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChange({target:{name:'frequencyStartMinute', value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <div className="time-of-day_dominion" onClick={()=> this.onChange({target:{name:'frequencyStartDominion', value:frequencyStartDominion==='AM'?'PM':'AM'}})}>{frequencyStartDominion}</div>
                        <div className="time-of-day_divider">-</div>
                        <div className="time-of-day_label">To</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={timeOfDay.filter(c => c.value === frequencyEndHour)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={timeOfDay}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChange({target:{name:'frequencyEndHour', value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={minutes.filter(c => c.value === frequencyEndMinute)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={minutes}
                            isSearchable={false}
                            placeholder=''
                            onChange={(event) => {
                              this.onChange({target:{name:'frequencyEndMinute', value:event}});
                              }}
                            styles={timeCustomStyle}
                        />
                        <div className="time-of-day_dominion" onClick={()=> this.onChange({target:{name:'frequencyEndDominion', value: frequencyEndDominion==='AM'?'PM':'AM'}})}>{frequencyEndDominion}</div>
                        
                    </div>
                    <div className="break-container">
                      {breakData.length>0 && <div className="break-container_label">Break</div>}
                      {breakData.map((data,index)=>this.gerBreakComponent(index,data))}
                      <div className="break-container_btn"onClick={this.addBreak}>+ Add Break</div>
                    </div>
                    <div className="frequency-type">
                        <div className="label">Appointment type(s)</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={filterService(services).filter(item1 =>this.state?.services.some(item2 => item2.id === item1.id))}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            options={_.sortBy(filterService(services),['name'])}
                            isMulti
                            noOptionsMessage={() => null}
                            onChange={(event) => {
                              this.onChange({target:{name:'services', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                        />
                    </div>
                    {groupByKey !== 'resource_ids'?
                    (<div className="frequency-type">
                        <div className="label">Operatory</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={resources.filter(item1 =>this.state?.resource.some(item2 => item2.id === item1.id))}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            options={_.sortBy(resources,['name'])}
                            isMulti={!editSchedule}
                            noOptionsMessage={() => null}
                            onChange={(event) => {
                              this.onChange({target:{name:'resource', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                        />
                    </div>):
                    (<div className="frequency-type">
                    <div className="label">Provider</div>
                    <Select
                        components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                        value={staffs.filter(item1 =>this.state?.staffs.some(item2 => item2.id === item1.id))}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option.id}
                        options={_.sortBy(staffs,['name'])}
                        isMulti={!editSchedule}
                        noOptionsMessage={() => null}
                        onChange={(event) => {
                          this.onChange({target:{name:'staffs', value:event}});
                          }}
                        styles={dropdownCustomStyle}
                    />
                </div>)}
                    <div className="frequency-type">
                        <div className="label">Appointment booking preference</div>
                        <Select
                            components={{ DropdownIndicator, IndicatorSeparator: () => null }}
                            value={prefrenceDropdown.filter(c => c.value === preference)}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value}
                            options={prefrenceDropdown}
                            onChange={(event) => {
                              this.onChange({target:{name:'preference', value:event}});
                              }}
                            styles={dropdownCustomStyle}
                        />
                    </div>
              </div>
              <div className="actions">
                  <button className="btn btn--primary btn--lg" disabled={this.disabledAddButton()} onClick={this.addTime}>{schedules?.addScheduleDefinition? (editSchedule?'UPDATING..':'ADDING'):(editSchedule?'UPDATE':'ADD')}</button>
                  <button className="btn btn--secondary btn--lg" onClick={closeServiceModal}>CANCEL</button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default InstallLayover;
